

jQuery(document).ready(function (jQuery) {
	//Elements to inject
	var elementsToInject = document.querySelectorAll('.inject-me');
	// Options
	var injectorOptions = {
		evalScripts: 'once'
	};
	// Trigger the injection
	var injector = new SVGInjector(injectorOptions);
	if (jQuery(elementsToInject).length) {
		injector.inject(
			elementsToInject
		);
    }


    $(".vote").hover(function() {
        $(".hover-vote").stop().css({"transform" : "scale(1)", "opacity" : "1"});
    }, function() {
        $(".hover-vote").stop().css({"transform" : "scale(.7)", "opacity" : "0"});
    });

    $(".user").hover(function() {
        $(".hover-search").stop().css({"transform" : "scale(1)", "opacity" : "1"});
    },  function() {
        $(".hover-search").stop().css({"transform" : "scale(.7)", "opacity" : "0"});
    });

    $(".search").hover(function() {
        $(".hover-user").stop().css({"transform" : "scale(1)", "opacity" : "1"});
    }, function() {
        $(".hover-user").stop().css({"transform" : "scale(.7)" , "opacity" : "0"});
    });


    $(".data").hover(function() {
        $(".hover-data").stop().css({"transform" : "scale(1)" , "opacity" : "1"});
    }, function() { 
        $(".hover-data").stop().css({"transform" : "scale(.7)", "opacity" : "0"});
    });


    $(".dropdown-menu").click(function() {
        $(".dropdown-menu").addClass("show");
    });

    $(".dropdown-menu.show").click(function() {
        $(".dropdown-menu").removeClass("show");
    });

});








